import { useGetIdentity, useListContext, useTranslate } from "ra-core";
import { CreateButton } from "@/components/admin/create-button";
import { List } from "@/components/admin/list";

import { MobileContent } from "../layout/MobileContent";
import MobileHeader from "../layout/MobileHeader";
import { CompanyEmpty } from "./CompanyEmpty";
import { ImageList } from "./GridList";

export const CompanyListMobile = () => {
  const { identity } = useGetIdentity();
  if (!identity) return null;
  return (
    <List
      title={false}
      perPage={25}
      sort={{ field: "name", order: "ASC" }}
      actions={false}
      pagination={false}
    >
      <CompanyListMobileLayout />
    </List>
  );
};

const CompanyListMobileLayout = () => {
  const { data, isPending } = useListContext();
  const translate = useTranslate();

  if (isPending) return null;
  if (!data?.length) return <CompanyEmpty />;

  return (
    <>
      <MobileHeader>
        <div className="flex items-center justify-between w-full">
          <h1 className="text-xl font-semibold">
            {translate("resources.companies.name", { smart_count: 2 })}
          </h1>
          <CreateButton
            label={translate("resources.companies.action.new", {
              _: "New",
            })}
          />
        </div>
      </MobileHeader>
      <MobileContent>
        <ImageList />
      </MobileContent>
    </>
  );
};
